import { AppLayoutSettings } from "../../common/styles/common.styles"

export const getCloseIconStyle = () => {
  return {
    color: 'windowText',
    selectors: {
      [`:focus`]: {
        border: '2px solid windowText !important'
      }
    }
  }
}

export const getCloseIconStyleInLightMode = () => {
  return {
    color: `${AppLayoutSettings.getAppColorContainer().whiteColor.value}`,
    selectors: {
      [`:focus`]: {
        border: `2px solid ${AppLayoutSettings.getAppColorContainer().whiteColor.value} !important`
      }
    }
  }
}